import _ from "lodash";

import Stack from "components/Stack";

import NoProformaUploaded from "entities/Memo/components/Sections/NoProformaUploaded";
import { useProformaForDealManager } from "entities/Memo/utils";
import IncomeAndOpexTable from "entities/Proforma/components/ProformaIncomeAndOpex/IncomeAndOpexTable";

import PrintableSectionSummary from "../PrintableSectionSummary";

interface IPrintableSectionIncomeAndOpex {
  dealId: number;
  externalToken?: string;
}

const PrintableSectionIncomeAndOpex = ({
  dealId,
  externalToken,
}: IPrintableSectionIncomeAndOpex) => {
  const { data: proforma } = useProformaForDealManager({
    token: externalToken,
    dealId,
  });

  return (
    <>
      {proforma &&
      proforma.core_data &&
      !_.isNull(proforma.income_operating_cost) ? (
        <Stack spacing={2} data-testid="income-and-opex-section">
          <Stack justifyContent="space-between" spacing={3}>
            <IncomeAndOpexTable
              incomeOperatingCost={proforma.income_operating_cost}
              totalUnits={proforma.core_data.total_units}
              showChart={false}
            />
            <PrintableSectionSummary
              title="Income &amp; OPEX description"
              category="Incone Descriptions"
              dealId={dealId}
              externalToken={externalToken}
            />
          </Stack>
        </Stack>
      ) : (
        <NoProformaUploaded title="Income &amp; OPEX" />
      )}
    </>
  );
};

export default PrintableSectionIncomeAndOpex;
